import { Box, SxProps, Theme } from '@mui/material';
import { FormDatepickerField } from 'components/forms';
import { IEditDeviationFormChildrenProps } from 'pages/managePricing/editDeviationForm';
import { useEffect } from 'react';
import { add48HoursToDate } from 'shared/utility';
import { IAddDeviationFormChildrenProps } from './AddDeviationForm';

const boxStyles: SxProps<Theme> = {
    gridColumn: 3,
};

export function EffectiveDate({ index, control, watch, setValue, errors }: IAddDeviationFormChildrenProps) {
    const name =
        `addedDeviations.${index}.modelCurrentPrice.startdate` as `addedDeviations.${number}.modelCurrentPrice.startdate`;
    const effectiveDateValue = watch ? watch(name) : '';

    const expirationDateName =
        `addedDeviations.${index}.modelCurrentPrice.enddate` as `addedDeviations.${number}.modelCurrentPrice.enddate`;

    useEffect(() => {
        if (effectiveDateValue && setValue) {
            setValue(expirationDateName, add48HoursToDate(effectiveDateValue));
        }
    }, [expirationDateName, effectiveDateValue, setValue]);

    return (
        <Box sx={boxStyles}>
            <FormDatepickerField
                name={name}
                label='Start Date'
                control={control}
                rules={{ required: 'Start Date is required' }}
                fieldError={errors?.['addedDeviations']?.[index]?.['modelCurrentPrice']?.['startdate']}
            />
        </Box>
    );
}

export function EditDeviationEffectiveDate({ control, watch, setValue, errors }: IEditDeviationFormChildrenProps) {
    const name = `modelCurrentPrice.startdate`;
    const effectiveDateValue = watch ? watch(name) : '';
    const expirationDateName = `modelCurrentPrice.enddate`;

    useEffect(() => {
        if (effectiveDateValue && setValue) {
            setValue(expirationDateName, add48HoursToDate(effectiveDateValue));
        }
    }, [expirationDateName, effectiveDateValue, setValue]);

    return (
        <Box sx={boxStyles}>
            <FormDatepickerField
                name={name}
                label='Start Date'
                control={control}
                rules={{ required: 'Start Date is required' }}
                fieldError={errors?.['modelCurrentPrice']?.['startdate']}
                disabled={true}
            />
        </Box>
    );
}
